import axios from "axios";
import { transliterate } from "transliteration";
import { ir } from "../check_domain_ir";
import Vue from "vue";

export default class StoreShopContent {
  constructor(qr_id) {
    this.id = qr_id;
    this.api = null;
    this.#initAxios();
  }

  #initAxios() {
    let id_token = localStorage.getItem("id_token");

    this.api = axios.create({
      baseURL: ir(process.env.VUE_APP_URL),
      timeout: 15000,
      headers: {
        Authorization: !!id_token ? "Bearer " + id_token : undefined,
        Accept: "application/json",
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      },
    });
  }

  initCategories(data) {
    return data.map((item) => {
      return {
        source_id: item.source_id,
        status: item.status || "active",
        id: item.id || null,
        name: item.title || item.name,
        picture: item.icon || item.picture,
        qr_id: this.id,
        ...(!!item.children?.length
          ? { children: this.initCategories(item.children) }
          : {}),
      };
    });
  }

  storeCategories(computedItems) {
    let items = this.initCategories(computedItems);

    return new Promise((resolve, reject) => {
      this.api
        .post("/v1/testQr/category-menus", items)
        .then(({ data }) => {
          resolve(data);

          // this.storeProducts(data.data, computedItems)
          //     .then(data => resolve(data))
          //     .catch(err => reject(err))
        })
        .catch((err) => reject(err));
    });
  }

  storeProducts(savedCats, computedItems) {
    let categories = new Array(...savedCats);

    return new Promise((resolve, reject) => {
      let arr = this.processItems(computedItems, categories);

      if (!arr.length) {
        resolve("noChange");
        return;
      }

      const formData = new FormData();
      formData.append("products", JSON.stringify(arr));

      this.api
        .post("/v1/testQr/product", formData, {
          timeout: 100000,
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then(({ data }) => resolve([]))
        .catch(({ response }) => {
          reject(response);
        });
    });
  }

  processItems(items, categories) {
    return items
      .map((item, i) => {
        if (item?.children?.length) {
          // Process children recursively
          return this.processItems(
            item.children,
            categories[i].children,
          ).flat();
        } else if (item?.products?.length) {
          // Process products
          return item.products
            .filter((product) => !product.id)
            .map((product) => this.returnListObject(product, categories[i].id));
        }
        return [];
      })
      .filter((subItem) => !!subItem && !!subItem.length)
      .flat();
  }

  returnListObject(item, cat_id = null) {
    const { transliterate } = require("transliteration");

    function slugify(str) {
      return transliterate(str)
        .toLowerCase()
        .trim()
        .replace(/[\s\W-]+/g, "-") // Replace spaces and non-word characters with a hyphen
        .replace(/^-+|-+$/g, ""); // Remove leading and trailing hyphens
    }

    return {
      ...item,
      status: "active",
      qr_id: this.id,
      category_id: cat_id,
      slug: slugify(item.name + " " + item.price),
      discount_type: item.discount_type === "price" ? "price" : "percent",
      discount_amount: item.discount,
      gallery:
        typeof item.gallery === "string"
          ? item.gallery
          : JSON.stringify(item.gallery),
      extra: JSON.stringify(item.details),
      quantity: item.quantity || null,
    };
  }

  storeProductsByTemplateIds({ category_id, ids = [] }) {
    return new Promise((resolve, reject) => {
      this.api
        .post("/v1/testQr/productTemplate", {
          qr_id: this.id,
          category_id,
          ids,
        })
        .then(({ data }) => resolve(data))
        .catch(({ response }) => reject(response));
    });
  }

  storeProductFromTemplateModel(savedCats, computedItems) {
    let arr = {};

    function getIdsFromCategory(categories, realCats) {
      categories.forEach((item, i) => {
        if (item?.children?.length)
          getIdsFromCategory(item.children, realCats[i].children);
        else if (item?.ids_list?.length) arr[realCats[i].id] = item.ids_list;
      });
    }

    return new Promise((resolve, reject) => {
      getIdsFromCategory(computedItems, savedCats);

      this.api
        .post("/v1/testQr/productModelTemplate", {
          qr_id: this.id,
          ids: JSON.stringify(arr),
        })
        .then(({ data }) => resolve(data))
        .catch(({ response }) => reject(response));
    });
  }
}
